<aside class="block app-sidewtn" [ngClass]="{ block: !onlyResults, 'only-results': onlyResults }">
    <div class="header" [hidden]="onlyResults">
        <div class="head">U.T.R</div>
        <div class="description">ID: {{ id }}</div>
    </div>
    <div class="results" [ngClass]="{ 'only-results': onlyResults }">
        <div class="sidebar">
            <div [lazyReactComponent]="WtnScale" [props]="WtnScaleProps"></div>
        </div>
    </div>
</aside>
